"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
exports.snapSubtitleDelay = exports.SUBTITLES_DELAY_STEP_MS = void 0;
var SUBTITLES_DELAY_STEP_MS = 100;
exports.SUBTITLES_DELAY_STEP_MS = SUBTITLES_DELAY_STEP_MS;
var snapSubtitleDelay = function (delay, direction) {
    var snap = direction > 0 ? Math.floor : Math.ceil;
    return snap(delay / SUBTITLES_DELAY_STEP_MS) * SUBTITLES_DELAY_STEP_MS;
};
exports.snapSubtitleDelay = snapSubtitleDelay;
